import React from "react";
import { Switch } from "react-router-dom";
import Route from "./Routes";
import Login from "../pages/Login";
import LoginQRCode from "../pages/LoginQRCode";
import WelcomeHome from "../pages/Welcome";
import ConfirmePhone from "../pages/ConfirmePhone";
import RedirectToStore from "../pages/RedirectToStore";
import Contrate from "../pages/Contrate";
import Token from "../pages/VerifyToken";
import TourLeague from "../pages/TourLeague";
import InviteFriend from "../pages/InviteFriend";
import ReadyToGo from "../components/ReadyToGo";
import FormState from "../components/welcome/Cadastro/CadastroState";
import PrepareLogin from "../pages/Login/PrepareLogin";
import Influencers from "../pages/Influencers";
import RedirectTo from "../pages/RedirectTo";
import OnboardForgotPassword from "../pages/OnboardForgotPassword/InitialScreen";

// import Cadastro from '../pages/Register';
// import Plans from '../pages/Plans';
// import Researches from '../pages/Researches';
// import ConfirmePayment from '../pages/Plans/ConfirmePayment';
// import Premium from '../components/welcome/Premium';
// import AlreadyUserRegistered from '../../old/components/welcome/AlreadyUserRegistered';
// import Processing from '../components/welcome/Processing';
// import RegisterAddress from '../pages/Register/RegisterAddress';
// import DetailPayment from '../pages/Plans/DetailPayment';
// import CardUpdateMessage from '../components/welcome/CardUpdateMessage';
// import ViewMessage from '../components/welcome/ViewMessage';
// import WelcomeToPremium from '../components/welcome/WelcomeToPremium';
// import CheckoutDetails from '../pages/CheckoutDetails';
// import CheckoutConfirm from '../pages/CheckoutConfirm';
// import CheckoutSuccessMessage from '../pages/CheckoutSuccessMessage';
// import CheckoutErrorMessage from '../pages/CheckoutErrorMessage';
// import FeaturePlanContrate from '../pages/FeaturePlanContrate';
// import MarketPlaceContrate from '../pages/MarketPlace/MarketPlaceContrate';
// import MarketPlaceDetails from '../pages/MarketPlace/MarketPlaceDetails';
// import MarketPlaceConfirm from '../pages/MarketPlace/MarketPlaceConfirm';
// import MarketPlaceSuccessMessage from '../pages/MarketPlace/MarketPlaceSuccessMessage';
// import MarketDetails from '../pages/MarketPlaceV2/MarketDetails';
// import OnboardSuccessWelcome from '../pages/MarketPlaceV2/Onboard/OnboardSuccessWelcome';
// import MarketDetailsFree from '../pages/MarketPlaceV2/MarketDetailsFree';
// import ReativarPlano from '../pages/ReativarPlano';
// import AddCreditCard from '../pages/AddCreditCard';
// import MarketPlaceCourse from '../pages/MarketPlaceCourse';

export default function Routes() {
	return (
		<Switch>
			{/* LOGIN */}
			<Route path="/" exact={true} component={Login} />
			<Route path="/onboard/login" component={Login} />
			<Route path="/onboard/reativar/:reactive_path" component={Login} />
			<Route path="/onboard/updadrade-pro-authentication" component={Login} />
			<Route path="/onboard/login-plan/:id_plan" component={Login} />
			<Route path="/onboard/league/my-league/:id_league" component={Login} />
			<Route path="/onboard/pontos" component={Login} />
			<Route path="/onboard/redirect/:redirect_path" component={Login} />
			<Route path="/onboard/redirect" component={Login} />
			<Route path="/onboard/campanha/:cod_campaign/liga/:id_league" component={Login} />
			<Route path="/onboard/campanha/:campaign/parceiro/:id_research" component={Login} />
			<Route path="/onboard/promocao/:cd_promotional" component={Login} />
			<Route path="/onboard/login-tour-liga/:id_league" component={Login} />
			<Route path="/onboard/login-qr-code" component={LoginQRCode} />
			<Route path="/onboard/token/:token" component={Token} />
			<Route path="/onboard/prepare-login" component={PrepareLogin} />

			{/* LIGAS */}
			<Route path="/onboard/tour-liga/:idLeague" component={TourLeague} />

			{/* ONBOARD */}
			<Route path="/onboard/welcome" component={WelcomeHome} />
			<Route path="/onboard/welcome-register" component={WelcomeHome} />
			<Route path="/onboard/recover-account" component={OnboardForgotPassword} />
			<Route path="/onboard/confirma-fone" component={ConfirmePhone} />
			<Route path="/onboard/cadastro-trademap" component={FormState} />

			{/* LOJA */}
			<Route path="/onboard/redirecionar-loja" component={RedirectToStore} />

			{/* CONTRATE */}
			<Route
				path="/onboard/contrate-promocao/:plan/promocao/:cd_promotional/:id_influencer?"
				component={Contrate}
			/>
			<Route
				path="/onboard/combo-promocional/:combo_promotional/:id_influencer?"
				component={Contrate}
			/>
			<Route
				path="/onboard/contrate/:campaign/:plan/parceiro/:id_research"
				component={Contrate}
			/>
			<Route path="/onboard/contrate/:plan" component={Contrate} />
			<Route path="/onboard/checkout/:idservice" component={Contrate} />
			<Route path="/onboard/combos/:cdcombo" component={Contrate} />

			{/* REDIRECIONADOR */}
			<Route path="/onboard/go" component={RedirectTo} />

			{/* ROTAS DE CONVITE */}
			<Route path="/onboard/amigo-convidado/:username" component={InviteFriend} />

			{/* INFLUENCIADORES */}
			<Route path="/onboard/influencers/:id_influencer?" component={Influencers} />

			{/* ROTA DE FINALIZAÇÃO */}
			<Route path="/onboard/congratulations" component={ReadyToGo} />

			{/* <Route path="/onboard/cadastro" component={Cadastro} /> */}
			{/* <Route path="/onboard/endereco" component={RegisterAddress} /> */}
			{/* <Route path="/onboard/planos" component={Plans} /> */}
			{/* <Route path="/onboard/researches/:plan_title" component={Researches} /> */}
			{/* <Route path="/onboard/resumo-de-pagamento" component={DetailPayment} /> */}
			{/* <Route path="/onboard/editar-pagamento/:token" component={ConfirmePayment} /> */}
			{/* <Route path="/onboard/confirme-pagamento" component={ConfirmePayment} /> */}
			{/* REVER */}
			{/* <Route path="/onboard/upgrade/adicionar-novo-cartao" component={AddCreditCard} /> */}
			{/* <Route path="/onboard/premium" component={Premium} /> */}
			{/* <Route path="/onboard/already-user-registered" component={AlreadyUserRegistered} /> */}
			{/* <Route path="/onboard/processando" component={Processing} /> */}
			{/* <Route path="/onboard/card-upgraded" component={CardUpdateMessage} /> */}
			{/* <Route path="/onboard/already-have-research-account" component={ViewMessage} /> */}
			{/* <Route path="/onboard/welcome-to-premium" component={WelcomeToPremium} /> */}
			{/* <Route path="/onboard/reativar-plano" component={ReativarPlano} /> */}
			{/* <Route path="/onboard/aproveite/:codeplan" component={FeaturePlanContrate} /> */}
			{/* featured-plans */}
			{/* <Route path="/onboard/checkout-details/:page" component={CheckoutDetails} /> */}
			{/* <Route path="/onboard/checkout-confirm" component={CheckoutConfirm} /> */}
			{/* <Route path="/onboard/checkout-success" component={CheckoutSuccessMessage} /> */}
			{/* <Route path="/onboard/error/:code" component={CheckoutErrorMessage} /> */}
			{/* Market Place */}
			{/* <Route path="/onboard/market-place/:codeplan" component={MarketPlaceContrate} /> */}
			{/* <Route path="/onboard/aproveite-agora/:codeplan" component={MarketPlaceContrate} /> */}
			{/* <Route path="/onboard/aproveite-agora-checkout/:codeplan" component={MarketDetailsFree} /> */}
			{/* <Route path="/onboard/market-place-details" component={MarketPlaceDetails} /> */}
			{/* <Route path="/onboard/market-place-details/:cd_product" component={MarketPlaceDetails} /> */}
			{/* <Route path="/onboard/market-place-confirm" component={MarketPlaceConfirm} /> */}
			{/* <Route path="/onboard/market-place-confirm/:cd_product" component={MarketPlaceConfirm} /> */}
			{/* <Route path="/onboard/market-place-success" component={MarketPlaceSuccessMessage} /> */}
			{/* <Route path="/onboard/market-place-success/:cd_product" component={MarketPlaceSuccessMessage} /> */}
			{/* Novo market place full */}
			{/*<Route path="/onboard/market/:codeplan" component={MarketDetails} />*/}
			{/* <Route path="/onboard/market/:codeplan/:routestep" component={MarketDetails} /> */}
			{/* Novo chekout de curso generico*/}
			{/* <Route path="/onboard/marketplace/:codeplan/:routestep" component={MarketPlaceCourse} /> */}
		</Switch>
	);
}
